import React from "react";

import useFilters from "hooks/useFilters";

import Button from "components/botanic/Button";

export const DeliveryProductNoResults: React.FC = () => {
  const { clearAllFilters } = useFilters({ shallowRouting: false });
  return (
    <div className="mb-xxl">
      <div className="mb-lg">No matching results.</div>
      <Button variant="primary" onClick={() => clearAllFilters()}>
        shop all products
      </Button>
    </div>
  );
};

export default DeliveryProductNoResults;
